import { render, staticRenderFns } from "./Busy.vue?vue&type=template&id=2d05c18d&scoped=true&"
import script from "./Busy.vue?vue&type=script&lang=js&"
export * from "./Busy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d05c18d",
  null
  
)

export default component.exports